import React from "react"
import Grid from "@mui/material/Grid/Grid";
import {Button, Typography} from "@mui/material";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles({
    title: {
        fontSize: '24px',
        fontWeight: 'bold',
    },
    label: {
        fontSize: '16px',
        marginBottom: '20px'
    },
});


export const CreatePreview = ({edit}) => {
    const classes = useStyles();

    return (
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            style={{ minHeight: '100vh' }}
        >
            <Grid item xs={3}>
                <Typography className={classes.title} component="h2">Please create your first segment</Typography>
                <Typography className={classes.label} component="div">The segment can be used to determine who is eligable for which category of prizes</Typography>
                <Button variant="contained" onClick={() => edit()}>Create Segment</Button>
            </Grid>
        </Grid>
    )
}